import { LegendItemProps } from "./functions";

//Refresh del monitor live ogni 60sec
export const MONITOR_LIVE_REFRESH_MSEC: number = 60000;

//Refresh del monitor live ITALTEX ogni 30sec
export const MONITOR_LIVE_ITALTEX_REFRESH_MSEC: number = 30000;

//Refresh del monitor live ogni 5sec
export const MONITOR_LIVE_HD_REFRESH_MSEC: number = 5000;

export const MONITOR_LIVE_STATUS: LegendItemProps[] = [
  {
    title: "monitor.status_produzione",
    className: "bg-success text-white",
  },
  {
    title: "monitor.status_attrezzaggio",
    className: "bg-primary text-white",
  },
  {
    title: "monitor.status_fermo_macchina",
    className: "bg-warning text-white",
  },
  {
    title: "monitor.status_sotto_produzione",
    className: "bg-danger text-white",
  },
  {
    title: "monitor.status_non_definito",
    className: "bg-dark text-white",
  },
];

export const MONITOR_LIVE_PRESSA_STATUSES = {
  PRODUZIONE: 1,
  SOTTOPRODUZIONE: 2,
  FERMO_MACCHINA: 3,
  ATTREZZAGGIO: 4,
  ND: 5,
};
